import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import { QUERY_KEYS } from '@/lib/constants';
import type { PaginatedResponse, ApiResponse, TrainingLog, ConversationTurn } from './types';

interface LogsFilter {
  log_type?: string;
  offset?: number;
  limit?: number;
  date_from?: string;
  date_to?: string;
  card_id?: string;
}

export function useLogs(filter: LogsFilter = {}) {
  const params = new URLSearchParams();
  if (filter.log_type) params.set('log_type', filter.log_type);
  if (filter.offset !== undefined) params.set('offset', String(filter.offset));
  if (filter.limit) params.set('limit', String(filter.limit));
  if (filter.date_from) params.set('date_from', filter.date_from);
  if (filter.date_to) params.set('date_to', filter.date_to);
  if (filter.card_id) params.set('card_id', filter.card_id);
  const qs = params.toString();

  return useQuery({
    queryKey: [...QUERY_KEYS.logs, filter],
    queryFn: () => api.get<PaginatedResponse<TrainingLog>>(`/api/v1/logs${qs ? `?${qs}` : ''}`),
  });
}

export function useLog(id: string) {
  return useQuery({
    queryKey: QUERY_KEYS.log(id),
    queryFn: () => api.get<ApiResponse<TrainingLog>>(`/api/v1/logs/${id}`),
    select: (res) => res.data,
    enabled: !!id,
  });
}

export function useConversation(logId: string) {
  return useQuery({
    queryKey: QUERY_KEYS.conversation(logId),
    queryFn: () => api.get<ApiResponse<ConversationTurn[]>>(`/api/v1/logs/${logId}/conversation`),
    select: (res) => res.data,
    enabled: !!logId,
  });
}
